<template>
  <router-link to="/">
    <div class="flex items-center">
      <img 
        src="/images/logo-horizontal.png"
        alt="AutoVolt.ai"
        class="w-auto"
        style="height: 40px !important; margin-top: -5px"
      />
    </div>
  </router-link>
</template>
